import { render, staticRenderFns } from "./subtitle.vue?vue&type=template&id=34d11dce&scoped=true"
import script from "./subtitle.vue?vue&type=script&lang=js"
export * from "./subtitle.vue?vue&type=script&lang=js"
import style0 from "./subtitle.vue?vue&type=style&index=0&id=34d11dce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d11dce",
  null
  
)

export default component.exports